/**
 * @fileoverview This file is generated by the Angular 2 template compiler.
 * Do not edit.
 * @suppress {suspiciousCode,uselessCode,missingProperties}
 */
 /* tslint:disable */

export const styles:any[] = ['.alert[_ngcontent-%COMP%] {\r\n    margin-bottom:0;\r\n}'];


// WEBPACK FOOTER //
// ./$$_gendir/src/app/shared/components/status.component.css.shim.ngstyle.ts